<template>
  <div style="padding-top: 1px">
    <Header :title="'在线纪念'" />
    <div v-show="list.length" class="container">
      <div class="list-container">
        <div v-for="item of list" :key="item.id" class="itemBox">
          <div class="left">
            <img
              v-if="item.memberId == 0"
              src="@/assets/images/default.png"
              @error="$defImg(require('@/assets/images/avatar-default.png'))"
            >
            <img
              v-else
              :src="$resUrl(item.member.headPicture)"
              @error="$defImg(require('@/assets/images/avatar-default.png'))"
            >
          </div>
          <div class="right">
            <div class="title texts-cut">{{ item.content }}</div>
            <div class="msg flex-row-between-center">
              <div class="msg-item msg-name text-cut">
                <i class="iconfont">&#xe664;</i>
                <span>{{ item.name }}</span>
              </div>
              <div class="msg-item">
                <i class="iconfont">&#xe714;</i>
                <span>{{ item.updatedDate }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 分页 -->
    <div v-show="list.length" class="pagination">
      <van-pagination
        v-model="pageIndex"
        :total-items="total"
        :show-page-size="3"
        :items-per-page="pageSize"
        force-ellipses
        @change="pageChange"
      />
    </div>
    <div v-show="list.length === 0" class="noData">暂无留言数据</div>
    <div class="btnBox">
      <nut-button @click="addMsg">发表留言</nut-button>
    </div>
    <Footer :active="1" />
  </div>
</template>

<script>
import Vue from 'vue'
import { Pagination } from 'vant'
import { GetMsgBoard } from '@/api/Hall'
import Footer from './components/Footer'
import Header from '@/components/Header/Index'

Vue.use(Pagination)

export default {
  name: 'HallLeaveMsg',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      pageIndex: 1,
      pageSize: 4,
      total: 0,
      list: []
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    pageChange() {
      this.getList()
    },
    getList() {
      const params = {
        id: this.$route.params.id,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }
      GetMsgBoard(params).then(res => {
        res.data.rows.forEach(item => {
          item.updatedDate = item.updatedDate.split(':')[0] + ':' + item.updatedDate.split(':')[1]
        })
        this.total = res.data.total
        this.list = res.data.rows
      })
    },
    addMsg() {
      this.$router.push({
        path: '/hall/addMsg',
        query: {
          id: this.$route.params.id
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  margin: 20px 17px;
  padding: 10px 15px 15px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 0px 5px 4px #efefef;

  .list-container {
    .itemBox {
      display: flex;
      height: 66px;
      padding: 16px 0px;
      border-bottom: 1px solid #ccc;

      .left {
        width: 66px;
        height: 66px;
        border-radius: 6px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .right {
        padding-left: 10px;
        flex: 1;
        display: flex;
        flex-flow: column;
        justify-content: space-between;
        font-size: 13px;

        .title {
          word-break: break-all;
          line-height: 1.5;
          color: #787878;
        }

        .msg {
          .msg-item {
            font-size: 12px;

            i {
              margin-right: 4px;
              font-size: 12px;
              color: #c1c1c1;
            }

            span {
              color: #999;
            }
          }
          .msg-name {
            max-width: 120px;
          }
        }
      }
    }
  }
}

.pagination {
  padding: 0px 15px 120px;

  .van-pagination {
    margin-bottom: 10px;
    justify-content: center;

    ::v-deep .van-pagination__item {
      color: #555;
      border-radius: 5px;
      margin: 0 3px;
      font-weight: bold;
      height: 35px;
    }

    ::v-deep .van-pagination__item::after {
      display: none;
    }

    ::v-deep .van-pagination__item:disabled {
      background: #fff;
      opacity: 1;
      color: #ddd;
    }

    ::v-deep .van-pagination__item:active {
      background-color: $primary-color-bright;
      color: #fff;
    }

    ::v-deep .van-pagination__item--disabled {
      background: #fff;
      opacity: 1;
      color: #ddd;
    }

    ::v-deep .van-pagination__item--active {
      background-color: #fff;
      color: $primary-color;
    }

    ::v-deep .van-pagination__prev {
      max-width: 150px;
    }

    ::v-deep .van-pagination__next {
      max-width: 150px;
    }
  }
}

.noData {
  padding-top: 30px;
  margin-bottom: 10px;
  text-align: center;
  color: #bbb;
}

.btnBox {
  // padding: 0px 15px 70px;
  position: fixed;
  bottom: 68px;
  width: 90%;
  left: 5%;

  .nut-button {
    background: $primary-color;
    width: 100%;
    height: 40px;
    font-size: 18px;
    border-radius: 6px;
  }
}
</style>
